import { createSlice } from '@reduxjs/toolkit';
import { TYPE_COMMON } from 'common/constant';
import i18n from 'i18n/i18n';

interface SelectType {
  value: string;
  label: string;
}
type AirMasterState = {
  transportData: SelectType[];
  dischargeTypeData: SelectType[];
  saleDeptData: SelectType[];
  searchByData: SelectType[];
  termData: SelectType[];
  blData: SelectType[];
  entityData: SelectType[];
  containerType: SelectType[];
  sqlType: SelectType[];
  authorityData: SelectType[];
  loginStatusData: SelectType[];
  userTypeData: SelectType[];
  dropListOfficeControl: any;
  saleOfficeData: SelectType[];
  salePersonData: SelectType[];
  blRefTypeData: SelectType[];
  langTypeData: any;
  dateFormatInData: any;
  numFormatData: any;
  dateFormatDispData: any;
  portTypeData: any;
  countryData: any;
  regionData: any;
  sqlCondition: any;
  statusModeData: any;
  inOutData: any;
  custClearReqStatusData: any;
  dlFlgData: any;
  shippingFormData: any;
  vehicleTypeData: any;
  dayOfWeekData: any;
  preTariffData: any;
  forwarderData: any;
  noticeType: any;
  readType: any;
  noticeItemHblBooking: any;
  noticeItemHblVesselInfo: any;
  noticeItemHblVesselMove: any;
  noticeItemCust: any;
  noticeItemCustExport: any;
  uploadFileMaxSizeCust: any;
  entityInforData: any;
  total: number;
  userGroup: any;
  sqlKnr: any;
  PODData: any;
  POLData: any;
  statusData: any;
  officeData: SelectType[];
  loadingPolSelector: boolean;
  loadingPodSelector: boolean;
  loading: boolean;
  message: string;
  isScrollBottom: boolean;
  titleHeader: string;
  userInfo: any;
  isBack: boolean;
  signedUrl: string;
  pdfDownload: boolean;
  chargeCdExportData: any;
  blTypeExportData: any;
  tradeType: SelectType[];
  deliveryFlgData: any;
};

const initialState: AirMasterState = {
  transportData: [],
  dischargeTypeData: [],
  saleDeptData: [],
  searchByData: [],
  termData: [],
  blData: [],
  entityData: [],
  containerType: [],
  sqlType: [],
  authorityData: [],
  loginStatusData: [],
  userTypeData: [],
  dropListOfficeControl: null,
  saleOfficeData: [],
  salePersonData: [],
  blRefTypeData: [],
  langTypeData: [],
  dateFormatInData: [],
  numFormatData: [],
  dateFormatDispData: [],
  portTypeData: [],
  countryData: [],
  regionData: [],
  sqlCondition: [],
  statusModeData: [],
  inOutData: [],
  custClearReqStatusData: [],
  dlFlgData: [],
  shippingFormData: [],
  vehicleTypeData: [],
  dayOfWeekData: [],
  preTariffData: [],
  forwarderData: [],
  noticeType: [],
  readType: [],
  noticeItemHblBooking: [],
  noticeItemHblVesselInfo: [],
  noticeItemHblVesselMove: [],
  noticeItemCust: [],
  noticeItemCustExport: [],
  uploadFileMaxSizeCust: [],
  entityInforData: [],
  total: 0,
  userGroup: [],
  sqlKnr: [],
  PODData: [],
  POLData: [],
  statusData: [],
  officeData: [],
  loadingPolSelector: false,
  loadingPodSelector: false,
  loading: false,
  message: '',
  isScrollBottom: false,
  titleHeader: '',
  userInfo: {},
  isBack: true,
  signedUrl: '',
  pdfDownload: false,
  chargeCdExportData: [],
  blTypeExportData: [],
  tradeType: [],
  deliveryFlgData: [],
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    getGeneralList: (state, action) => {},
    getGeneralListSuccess: (state, action) => {
      if (action.payload.type === TYPE_COMMON.STATUS) {
        state.statusData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.TRANS_TYPE) {
        state.transportData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.DISCHARGE) {
        state.dischargeTypeData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.DISCHARGE_EXPORT) {
        state.dischargeTypeData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.TERM) {
        state.termData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.BL_TYPE) {
        state.blData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.ENTITY_TYPE) {
        state.entityData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.CONT_TYPE) {
        state.containerType = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.SALE_DEPT) {
        state.saleDeptData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.SQL_TYPE) {
        state.sqlType = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.OFFICE_CD) {
        state.officeData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.SEARCH_BY_INT) {
        state.searchByData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.SEARCH_BY_INT_EXPORT) {
        state.searchByData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.AUTHORITY_CD) {
        state.authorityData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.LOGIN_STATUS) {
        state.loginStatusData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.SEARCH_USER_TYPE) {
        state.userTypeData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.SALES_OFFICE_CD) {
        state.saleOfficeData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.SALES_DEPT) {
        state.saleOfficeData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.SALES_PERSON_CD) {
        state.salePersonData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.BL_REF_TYPE) {
        state.blRefTypeData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.LANG_TYPE) {
        state.langTypeData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.DATE_FORMAT_IN) {
        state.dateFormatInData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.NUM_FORMAT) {
        state.numFormatData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.DATE_FORMAT_DISP) {
        state.dateFormatDispData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.PORT_TYPE) {
        state.portTypeData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.COUNTRY_CD) {
        state.countryData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.REGION_CD) {
        state.regionData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.SQL_CONDITION) {
        state.sqlCondition = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.STATUS_MODE) {
        state.statusModeData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.IN_OUT_FLG) {
        state.inOutData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.CUST_CLEAR_REQ_STATUS) {
        state.custClearReqStatusData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.CUST_CLEAR_REQ_STATUS_EXPORT) {
        state.custClearReqStatusData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.DL_FLG) {
        state.dlFlgData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.SHIPPING_FORM) {
        state.shippingFormData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.SHIPPING_FORM_EXPORT) {
        state.shippingFormData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.VEHICLE_TYPE) {
        state.vehicleTypeData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.VEHICLE_TYPE_EXPORT) {
        state.vehicleTypeData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.DAY_OF_WEEK) {
        state.dayOfWeekData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.PRE_TARIFF) {
        state.preTariffData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.PRE_TARIFF_EXPORT) {
        state.preTariffData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.CUST_CLEAR_REQ_FORWARDER) {
        state.forwarderData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.NOTICE_TYPE) {
        state.noticeType = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.READ_TYPE) {
        state.readType = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.NOTICE_ITEM_HBL_BOOKING) {
        state.noticeItemHblBooking = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.NOTICE_ITEM_HBL_VESSELMOVE) {
        state.noticeItemHblVesselMove = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.NOTICE_ITEM_CUST) {
        state.noticeItemCust = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.NOTICE_ITEM_CUST_EXP) {
        state.noticeItemCustExport = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.CHARGE_CD_EXPORT) {
        state.chargeCdExportData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.BL_TYPE_EXPORT) {
        state.blTypeExportData = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.TRADE_TYPE) {
        state.tradeType = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.CUST_UPLOAD_FILE_MAX_SIZE) {
        state.uploadFileMaxSizeCust = action.payload.response;
      }
      if (action.payload.type === TYPE_COMMON.DELIVERY_FLG) {
        state.deliveryFlgData = action.payload.response;
      }
    },
    getPODList: (state, action) => {
      state.loadingPodSelector = true;
    },
    setHeaderTitle: (state, action) => {
      state.titleHeader = action.payload;
    },
    getPODListSuccess: (state, action) => {
      state.PODData = action.payload;
      state.loadingPodSelector = false;
    },
    getPOLList: (state, action) => {
      state.loadingPolSelector = true;
    },
    getPOLListSuccess: (state, action) => {
      state.POLData = action.payload;
      state.loadingPolSelector = false;
    },
    getStatusList: (state, action) => {},
    getStatusListSuccess: (state, action) => {
      state.statusData = action.payload;
    },
    getEntityList: (state, action) => {
      state.loading = true;
    },
    getEntityListSuccess: (state, action) => {
      if (action.payload.total < 10000) {
        state.entityInforData = action.payload.data;
        state.total = action.payload.total;
        state.message = '';
      }
      if (action.payload?.total > 10000) {
        state.entityInforData = [];
        state.total = 0;
        state.message = i18n.t('message.common.0006');
      }
      if (action.payload.total === 0) {
        state.message = i18n.t('message.common.0001');
      }

      state.loading = false;
    },
    getGeneralDropListOffice: (state, action) => {
      state.loading = true;
    },
    getGeneralDropListOfficeSuccess: (state, action) => {
      state.dropListOfficeControl = action.payload?.length ? action.payload[0] : null;
      state.loading = false;
    },
    getUserInfor: () => {},
    getUserSuccess: (state, action) => {
      state.userInfo = action.payload;
    },
    cleanData: (state, action) => {
      state.entityInforData = action.payload.data;
      state.total = action.payload.total;
      state.message = '';
    },
    cleanStore: (state) => {
      return { ...initialState };
    },
    setIsBack: (state, action) => {
      state.isBack = action.payload;
    },
    getUserGrpList: (state, action) => {
      state.loading = true;
    },
    getUserGrpListSuccess: (state, action) => {
      state.userGroup = action.payload;
      state.loading = false;
    },
    getSignedUrl: (state, action) => {
      state.loading = true;
    },
    getSignedUrlSuccess: (state, action) => {
      state.signedUrl = action.payload.data;
      state.loading = false;
    },
    getSignedUrlFailure: (state, action) => {
      // state.loading = action.payload.loading;
      state.loading = false;
      state.message = action.payload.message;
    },
    compressFileDownload: (state, action) => {
      state.loading = true;
    },
    compressFileDownloadSuccess: (state, action) => {
      state.signedUrl = action.payload.data.signedUrl;
      state.loading = false;
    },
    compressFileDownloadFailure: (state, action) => {
      state.loading = action.payload.loading;
      state.message = action.payload.message;
    },
    clearSignedUrl: (state) => {
      state.signedUrl = '';
    },
    setPdfDownload: (state, action) => {
      state.pdfDownload = action.payload;
    },
  },
});

export const {
  getGeneralList,
  getGeneralListSuccess,
  getPODList,
  getPODListSuccess,
  getPOLList,
  getPOLListSuccess,
  getStatusList,
  getStatusListSuccess,
  getGeneralDropListOffice,
  getGeneralDropListOfficeSuccess,
  getEntityList,
  getEntityListSuccess,
  getUserInfor,
  getUserSuccess,
  setHeaderTitle,
  cleanData,
  cleanStore,
  setIsBack,
  getUserGrpList,
  getUserGrpListSuccess,
  getSignedUrl,
  getSignedUrlSuccess,
  getSignedUrlFailure,
  compressFileDownload,
  compressFileDownloadSuccess,
  compressFileDownloadFailure,
  clearSignedUrl,
  setPdfDownload,
} = commonSlice.actions;

export default commonSlice.reducer;
